export default "__VITE_ASSET__DsWkMUTk__"